import MembersService from '@/services/members'
import * as types from '../mutations'

const state = {
  totalMembersCount: 0,
  teamMembers: [],
  quota: {
    limit: 0,
    used: 0,
    remaining: 0
  }
}

const getters = {
  totalMembersCount: (state) => state.quota.limit,
  usedMembersCount: (state) => state.quota.used,
  teamMembers: (state) => state.teamMembers
}

const actions = {
  async loadTeamMembers ({ commit }) {
    const params = { is_active: true }
    const resultsData = await MembersService.getMembers(params)
    commit(types.SET_TEAM_MEMBERS, resultsData.results)
  },

  async addTeamMember ({ commit }, payload) {
    const newMember = await MembersService.addNewMember(payload)
    commit(types.ADD_TEAM_MEMBER, newMember)
  },

  async resetTeamMemberPassword ({ commit }, payload) {
    const { id } = payload
    await MembersService.resetMemberPassword(id)
  },

  async removeTeamMember ({ commit }, payload) {
    const { id } = payload
    await MembersService.removeMember(id)
    commit(types.REMOVE_TEAM_MEMBER, id)
  },

  async editTeamMemberDetails ({ commit }, payload) {
    const { id } = payload
    const results = await MembersService.editMemberInfo(id, payload)
    commit(types.UPDATE_TEAM_MEMBER, { memberId: id, updatedInfo: results })
  }
}

const mutations = {
  [types.SET_USERS_QUOTA] (state, quota) {
    state.quota = quota
  },

  [types.SET_TEAM_MEMBERS] (state, teamMembersList) {
    state.teamMembers = teamMembersList || []
  },

  [types.ADD_TEAM_MEMBER] (state, newMember) {
    state.teamMembers = [...state.teamMembers, newMember]
  },

  [types.REMOVE_TEAM_MEMBER] (state, memberId) {
    const index = state.teamMembers.findIndex(member => member.id === memberId)
    if (index !== -1) {
      state.teamMembers.splice(index, 1)
    }
  },

  [types.UPDATE_TEAM_MEMBER] (state, { memberId, updatedInfo }) {
    const index = state.teamMembers.findIndex(member => member.id === memberId)
    if (index !== -1) {
      Object.assign(state.teamMembers[index], updatedInfo)
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
